import styled from 'styled-components';

export const Wrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    height: 100lvh;

    pointer-events: none;

    @supports (-webkit-touch-callout: none) {
        // Fix for iOS only: Translate canvas instead of fixed position
        position: absolute;
    }

    canvas {
        width: 100%; //temp
        height: 100%; //temp
    }
`;
